/**
 * Handle boat's animation on hover behavior
 */

window.app = window.app || {};

(function (boatManager, $) {

    /**
     * block 360 selector
     * @type {string}
     * @private
     */
    var _block360 = '.model-360-block';

    /**
     * pictures 360 selector
     * @type {string}
     * @private
     */
    var _pictures360Class = ".picture-list img";

    /**
     * Interval initializer
     */
    var rotation;

    /**
     * Interval between each images during rotation (milliseconds)
     * @type {number}
     * @private
     */
    var _rotationInterval = 300;

    /**
     * Initializes the behavior.
     */
    boatManager.init = function () {
        _handleEvents();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $(_block360).hover(
            // hover over
            function(){
                _hoverOverBlock360($(this));
            },
            // hover out
            function(){
                _hoverOutBlock360($(this));
            }
        );

        if($(document).width() < 768){
            $(_block360).each(function(){
                _hoverOverBlock360($(this));
            });
        }
    };

    /**
     *
     * @private
     */
    var _hoverOverBlock360 = function(_block360OnHover) {
        var _pictures360 = $(_block360OnHover).find(_pictures360Class);

        if (_pictures360.length > 1) {
            $(_block360OnHover).addClass("block-360-is-over");
            _launchRotation(_pictures360);

            _pictures360.each(function() {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).attr('srcset', $(this).attr('data-srcset'));
            });

            rotation = setInterval(function(){ _launchRotation(_pictures360); }, _rotationInterval);
        }
    };

    /**
     *
     * @private
     */
    var _hoverOutBlock360 = function(_block360OnHoverOut) {
        $(_block360OnHoverOut).removeClass("block-360-is-over");
        var _pictures360 = $(_block360OnHoverOut).find(_pictures360Class);
        leaveRotation(_pictures360);
    };

    /**
     *
     * @param _pictures360
     * @private
     */
    var _launchRotation = function (_pictures360) {
        var current = _pictures360.filter(".current-rotate"); // get the current highlighted

        // if no current we're at the beginning of the rotation
        if ( !current.length ) {
            _pictures360.first().next().addClass("current-rotate");
            current = _pictures360.first();
        } else {
            var next = current.next();

            // if no next then we're at the end
            if( !next.length ) {
                next = _pictures360.first();
            }

            next.addClass('current-rotate');
            current.removeClass('current-rotate');
        }
    };

    /**
     *
     * @param _pictures360
     */
    var leaveRotation = function(_pictures360) {
        _pictures360.removeClass('current-rotate');
        clearInterval(rotation);
    };
})(
    window.app.boatManager = window.app.boatManager || {},
    jQuery
);
